import { Controller } from "@hotwired/stimulus"

import { getConsumer } from "@shared/lib/action-cable/consumer"

// CONEK-4671 P4 Task 5 — Subscribes to TaskChannel, CallSessionChannel, and
// BookingChannel and reloads the "your-day-agenda" Turbo Frame (this
// controller's own element) whenever any of them broadcasts. Mirrors
// telephony/call_insight_controller.js's subscribe/reload shape.
export default class extends Controller {
  static values = {
    frameUrl: String,
    spaceGroupId: String,
  }

  connect() {
    this.#subscribe()
  }

  disconnect() {
    ;(this.subscriptions || []).forEach((subscription) =>
      subscription.unsubscribe(),
    )
  }

  #subscribe() {
    const consumer = getConsumer(this.spaceGroupIdValue || "default")
    const received = (data) => this.#handleMessage(data)
    this.subscriptions = [
      "TaskChannel",
      "CallSessionChannel",
      "BookingChannel",
    ].map((channel) => consumer.subscriptions.create({ channel }, { received }))
  }

  #handleMessage(data) {
    // Defensive cross-tenant guard: the user's stream can carry events for
    // another tenant. Drop any payload not scoped to this frame's space
    // group when both sides know it. No space_group_id on the payload (or
    // on this frame) means "reload anyway" — matches the brief's behaviour.
    if (
      this.spaceGroupIdValue &&
      data?.space_group_id &&
      data.space_group_id !== this.spaceGroupIdValue
    )
      return

    // Set src to trigger the Turbo Frame (this controller's own element) to
    // fetch the updated agenda partial.
    if (this.frameUrlValue) this.element.src = this.frameUrlValue
  }
}
